module.exports = __webpack_public_path__ + "img/history.8c4de151.svg";